import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

/**
 * Drop-in replacement for react-router's Link that keeps the visitor in the
 * language they're browsing: internal paths get the "/en" prefix when the
 * current URL has one. Hash links, external URLs and /admin are left alone.
 */
const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...rest }, ref) => {
  const { localePath } = useLanguage();

  const shouldPrefix =
    typeof to === "string" &&
    to.startsWith("/") &&
    !to.startsWith("/en/") &&
    to !== "/en" &&
    !to.startsWith("/admin");

  return <Link ref={ref} to={shouldPrefix ? localePath(to as string) : to} {...rest} />;
});

LocaleLink.displayName = "LocaleLink";

export default LocaleLink;
